import { useEffect, useRef, useState } from "react"

export default function useNearScreen({
  distance = "100px",
  externalRef,
}: $TSMigrationFixMe = {}) {
  const [isNearScreen, setShow] = useState(false)
  const fromRef = useRef()

  useEffect(() => {
    let observer: $TSMigrationFixMe

    const onChange = (entries: $TSMigrationFixMe) => {
      const el = entries[0]
      setShow(el.isIntersecting)
    }

    Promise.resolve(
      typeof IntersectionObserver !== "undefined"
        ? IntersectionObserver
        : // @ts-expect-error TS(7016): Could not find a declaration file for module 'inte...
          import("intersection-observer")
    ).then(() => {
      observer = new IntersectionObserver(onChange, {
        rootMargin: distance,
      })

      if (externalRef?.current) observer.observe(externalRef.current)
    })

    return () => observer && observer.disconnect()
  })

  return { isNearScreen, fromRef }
}
